import { FormField, FormItem, FormControl, FormMessage, Form } from '@/components/ui/Form'
import { Input } from '@/components/ui/Input'
import { SegmentedButtons } from '@/components/ui/SegmentedButtons'
import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { formatEther } from 'viem'
import { testIdFactory } from '@/utils/test-id-factory.ts'

interface AmountFormProps<TForm extends UseFormReturn<any>> {
	base: bigint
	form: TForm
	disabled?: boolean
}

export function AmountForm<TForm extends UseFormReturn<any>>({ form, base, disabled }: AmountFormProps<TForm>) {
	const [optionsKey, setOptionsKey] = useState(0)

	return (
		<Form {...form}>
			<form noValidate>
				<FormField
					control={form.control}
					name="amount"
					render={({ field }) => (
						<FormItem>
							<FormControl>
								<Input
									data-testid={testIdFactory.pepperAmountFormInput()}
									className="disabled:cursor-default"
									placeholder="PEPPER"
									type="text"
									disabled={disabled}
									{...field}
									onChange={x => {
										const inputValue = x.target.value
										// Allow empty string, single decimal point, or valid decimal number
										if (inputValue === '' || inputValue === '.' || /^\d*\.?\d*$/.test(inputValue)) {
											setOptionsKey(optionsKey + 1)
											field.onChange(inputValue)
										}
									}}
								/>
							</FormControl>
							<SegmentedButtons
								key={optionsKey}
								onValueChange={x => {
									const value = (base * BigInt(x)) / 100n
									field.onChange(formatEther(value))
								}}
								defaultValue={form.formState.dirtyFields?.amount ? undefined : '100'}
								disabled={disabled}
								options={[
									{
										label: '25%',
										value: '25',
										dataTestId: testIdFactory.pepperAmountFormButton('25%')
									},
									{
										label: '50%',
										value: '50',
										dataTestId: testIdFactory.pepperAmountFormButton('50%')
									},
									{
										label: '75%',
										value: '75',
										dataTestId: testIdFactory.pepperAmountFormButton('75%')
									},
									{
										label: 'max',
										value: '100',
										dataTestId: testIdFactory.pepperAmountFormButton('max')
									}
								]}
							/>
							<FormMessage className="text-[1rem]" />
						</FormItem>
					)}
				/>
			</form>
		</Form>
	)
}
